export const STATUS_MAPPING = {
  0: "Draft",
  1: "Submitted",
  2: "Approved",
  3: "Rejected",
};
